export const MEGA_MENU_MAX_LENGTH = 4;
export const MEGA_MENU_PATH = '/shop/browse';
